export default "__VITE_ASSET__BVS8VU6k__"